module.exports = __webpack_public_path__ + "img/img-10-tarif.c3ff441c.png";